import { Patient } from '../patient/patient';
import { IRepository } from './repository';

/**
 * Simple in-memory {@link Patient} repository
 */

export class PatientRepository implements IRepository<Patient> {
    getAll(): Patient[] {
        return [...this.patients];
    }

    add(p: Patient, options?: { allowMultiplePatients?: boolean }) {
        if (!options?.allowMultiplePatients) {
            const loadedIds = this.patients.map((e) => e.dataSet.PatientID);
            if (
                loadedIds.length > 0 &&
                !loadedIds.includes(p.dataSet.PatientID)
            ) {
                // PatientIDs are PHI and must not reach the message.
                throw new Error(
                    'Cannot add patient with a different' +
                        ' PatientID when another patient is' +
                        ' already loaded.'
                );
            }
        }
        this.patients.push(p);
    }

    delete(id: string): boolean {
        const index = this.patients.findIndex((p) => p.id === id);
        if (index === -1) {
            return false;
        }
        this.patients.splice(index, 1);
        return true;
    }

    getByPatientId(patientId: string): Patient | null {
        return (
            this.patients.find((p) => p.dataSet.PatientID === patientId) ?? null
        );
    }

    getById(id: string): Patient | null {
        return this.patients.find((p) => p.id === id) ?? null;
    }

    private patients: Patient[] = [];
}
